<h1>Test Component</h1>

<div>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Buttons</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card padding-30">
                    <div class="row">
                        <div class="col-md-4">
                            <h4 class="card-title">Basic Buttons</h4>
                            <div class="mrg-top-20">
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-default"
                                    >Default</a
                                >
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-primary"
                                    >Primary</a
                                >
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-success"
                                    >Success</a
                                >
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-info"
                                    >Info</a
                                >
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-warning"
                                    >Warning</a
                                >
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-danger"
                                    >Danger</a
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h4 class="card-title">Inverse Button</h4>
                            <div class="mrg-top-20">
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-inverse btn-primary"
                                    >Primary</a
                                >
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-inverse btn-success"
                                    >Success</a
                                >
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-inverse btn-info"
                                >
                                    Info
                                </a>
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-inverse btn-warning"
                                >
                                    Warning
                                </a>
                                <a
                                    href="javascript:void(0);"
                                    class="btn btn-inverse btn-danger"
                                >
                                    Danger
                                </a>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h4 class="card-title">Buttons Size</h4>
                            <div class="mrg-top-20">
                                <div>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-default btn-lg"
                                    >
                                        btn-lg
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-info btn-lg"
                                    >
                                        btn-lg
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-default"
                                    >
                                        btn-md
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-info"
                                    >
                                        btn-md
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-default btn-sm"
                                    >
                                        btn-sm
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-info btn-sm"
                                    >
                                        btn-sm
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-default btn-xs"
                                    >
                                        btn-xs
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn-info btn-xs"
                                    >
                                        btn-xs
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="card">
                    <div class="padding-30">
                        <h4 class="card-title">Buttons Rounded</h4>
                        <div class="mrg-top-20">
                            <a
                                href="javascript:void(0);"
                                class="btn btn-default btn-rounded"
                            >
                                Default
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-primary btn-rounded"
                            >
                                Primary
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-success btn-rounded"
                            >
                                Success
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-info btn-rounded"
                            >
                                Info
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-warning btn-rounded"
                            >
                                Warning
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-danger btn-rounded"
                            >
                                Danger
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="padding-30">
                        <h4 class="card-title">Inverse Buttons Rounded</h4>
                        <div class="mrg-top-20">
                            <a
                                href="javascript:void(0);"
                                class="btn btn-default btn-inverse btn-rounded"
                            >
                                Default
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-primary btn-inverse btn-rounded"
                            >
                                Primary
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-success btn-inverse btn-rounded"
                            >
                                Success
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-info btn-inverse btn-rounded"
                            >
                                Info
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-warning btn-inverse btn-rounded"
                            >
                                Warning
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-danger btn-inverse btn-rounded"
                            >
                                Danger
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="padding-30">
                        <h4 class="card-title">Icon Buttons</h4>
                        <div class="mrg-top-20">
                            <a
                                href="javascript:void(0);"
                                class="btn btn-default"
                            >
                                <i class="ti-reload pdd-right-5"></i>
                                <span>Reset</span>
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-primary"
                            >
                                <i class="ti-zip pdd-right-5"></i>
                                <span>compile</span>
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-success"
                            >
                                <i class="ti-printer pdd-right-5"></i>
                                <span>Print</span>
                            </a>
                            <a href="javascript:void(0);" class="btn btn-info">
                                <i class="ti-export pdd-right-5"></i>
                                <span>Upload</span>
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-warning"
                            >
                                <i class="ti-comment pdd-right-5"></i>
                                <span>Comment</span>
                            </a>
                            <a
                                href="javascript:void(0);"
                                class="btn btn-danger"
                            >
                                <i class="ti-trash pdd-right-5"></i>
                                <span>Delete</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="padding-30">
                        <h4 class="card-title">Dropdown Buttons</h4>
                        <div class="mrg-top-20">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="mrg-btm-20">
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-default dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-primary dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="mrg-top-20">
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-success btn-rounded dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action</a
                                                    >
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-info btn-rounded dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="mrg-btm-20">
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-warning btn-inverse dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-danger btn-inverse dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="mrg-top-20">
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-primary btn-inverse btn-rounded dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="dropdown inline-block">
                                            <button
                                                class="btn btn-success btn-inverse btn-rounded dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                            >
                                                <span>Dropdown</span>
                                                <i
                                                    class="ti-angle-down font-size-9"
                                                ></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="#">Action</a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Another action
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        Something else here
                                                    </a>
                                                </li>
                                                <li class="divider"></li>
                                                <li>
                                                    <a href="#">
                                                        Seperated Link
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="padding-30">
                        <h4 class="card-title">Grouped Buttons</h4>
                        <div class="mrg-top-20">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="display-block">
                                        <div class="btn-group">
                                            <button
                                                type="button"
                                                class="btn btn-default"
                                            >
                                                <i class="ti-save"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-default"
                                            >
                                                <i class="ti-comments"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-default"
                                            >
                                                <i class="ti-heart"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="btn-group">
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <span>Left</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <span>Middle</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <span>Right</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="display-block">
                                        <div class="btn-group">
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                            >
                                                <i class="ti-save"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-primary active"
                                            >
                                                <i class="ti-comments"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                            >
                                                <i class="ti-heart"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="btn-group">
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <span>Left</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <span>Middle</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <span>Right</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="btn-group btn-group-vertical">
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <i class="ti-save"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <i class="ti-comments"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                        >
                                            <i class="ti-heart"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="padding-30">
                        <h4 class="card-title">Social Icon Buttons</h4>
                        <div class="mrg-top-20">
                            <div class="row">
                                <div class="col-md-5">
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-facebook btn-icon"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-twitter btn-icon"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-google-plus btn-icon"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-linkedin btn-icon"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-dribbble btn-icon"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-5">
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-primary btn-icon"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-info btn-icon"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-success btn-icon"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-danger btn-icon"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-warning btn-icon"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-primary btn-inverse btn-icon"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-info btn-inverse btn-icon"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-success btn-inverse btn-icon"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-danger btn-inverse btn-icon"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-warning btn-inverse btn-icon"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="padding-30">
                        <h4 class="card-title">Social Icon Buttons Rounded</h4>
                        <div class="mrg-top-20">
                            <div class="row">
                                <div class="col-md-5">
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon btn-rounded"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon btn-rounded"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon btn-rounded"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon btn-rounded"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-default btn-icon btn-rounded"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-facebook btn-icon btn-rounded"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-twitter btn-icon btn-rounded"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-google-plus btn-icon btn-rounded"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-linkedin btn-icon btn-rounded"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-dribbble btn-icon btn-rounded"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-5">
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-primary btn-icon btn-rounded"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-info btn-icon btn-rounded"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-success btn-icon btn-rounded"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-danger btn-icon btn-rounded"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-warning btn-icon btn-rounded"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="list-unstyle list-inline">
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-primary btn-inverse btn-icon btn-rounded"
                                            >
                                                <i class="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-info btn-inverse btn-icon btn-rounded"
                                            >
                                                <i class="ti-twitter"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-success btn-inverse btn-icon btn-rounded"
                                            >
                                                <i class="ti-google"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-danger btn-inverse btn-icon btn-rounded"
                                            >
                                                <i class="ti-linkedin"></i>
                                            </a>
                                        </li>
                                        <li
                                            class="list-inline-item no-pdd-horizon"
                                        >
                                            <a
                                                href="javascript:void(0);"
                                                class="btn btn-warning btn-inverse btn-icon btn-rounded"
                                            >
                                                <i class="ti-dribbble"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
